// eslint-disable-next-line import/no-unresolved
import { createClient } from 'data-api'
import { useMemo } from 'react'
import { COOKIE_NAME_JWT, COOKIE_NAME_SALES_AGENT_JWT } from '../constants'
import { useCurrency } from '../providers/currency'
import { useStore } from '../providers/store'
import { useUserData } from '../providers/user/user-data'
import { useSalesAgentData } from '../providers/sales-agent/sales-agent-data'
import { clientJwtRequestInterceptor, formatGroupCookieName } from '../utils'
import { useAuth } from './useAuth'
import { useConfig } from '../providers/config'

export const useClient = () => {
	const BH_VARY = process.env.NEXT_PUBLIC_BH_VARY
	const { code: store, groupId } = useStore()
	const { currency } = useCurrency()
	const { groupId: userGroup } = useUserData()
	const { groupId: salesAgentGroup } = useSalesAgentData()
	const { apiRegExpNoCacheHeaders } = useConfig()

	const client = useMemo(() => {
		const client = createClient({
			headers: {
				...(store ? { store } : {}),
				...(currency ? { currency } : {}),
				...(userGroup !== undefined ? { userGroup } : {}),
				...(salesAgentGroup !== undefined ? { salesAgentGroup } : {}),
				...(store && (currency || userGroup || salesAgentGroup)
					? { [BH_VARY]: `${currency}_${userGroup}_${salesAgentGroup}` }
					: {}),
			},
			baseURL: process.env.NEXT_PUBLIC_BH_PROXY_API_PATH_TO_EXPOSE,
		})

		client.interceptors.request.use(
			clientJwtRequestInterceptor(formatGroupCookieName(groupId, COOKIE_NAME_JWT)),
			null,
			{
				synchronous: true,
			}
		)
		client.interceptors.request.use(
			clientJwtRequestInterceptor(
				formatGroupCookieName(groupId, COOKIE_NAME_SALES_AGENT_JWT),
				'SalesAgentAuthorization'
			),
			null,
			{
				synchronous: true,
			}
		)

		client.defaults.apiRegExpNoCacheHeaders = apiRegExpNoCacheHeaders

		return client
	}, [store, groupId, currency, userGroup, salesAgentGroup, BH_VARY, apiRegExpNoCacheHeaders])

	const { authInit, authRefresh, handleInsufficientAuth } = useAuth(client)

	client.defaults.handleAuthInit = authInit
	client.defaults.handleAuthRefresh = authRefresh
	client.defaults.handleInsufficientAuth = handleInsufficientAuth

	return client
}
